import { render } from "./user.vue?vue&type=template&id=831bd46e&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=831bd46e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-831bd46e"

export default script